
import { ROUTES } from "@/router/constants";
import formatterHelper from "@/helpers/formatter";
import { useStore } from "vuex";
import { computed, defineComponent, onMounted } from "vue";
import { USER_ACTIONS, USER_GETTERS, USER_MUTATIONS } from "@/store/user";
import ELROND from "@/constants/elrond";
import { useRoute, useRouter } from "vue-router";
import avatarHelper from "@/helpers/avatar";

export default defineComponent({
  name: "SidebarAccount",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const formatAddress = (address: string) => {
      return formatterHelper.formatAddress(address);
    };

    const formatTokenTransfer = (balance: any) => {
      return formatterHelper.formatTokenTransfer(balance);
    };

    const goToAccountPage = () => {
      router.push({ name: ROUTES.accountDetails });
    };

    const logout = async () => {
      await store.dispatch(USER_ACTIONS.LOGOUT_ELROND);
      router.push({ name: ROUTES.home });
    };

    const address = computed(() => store.getters[USER_GETTERS.ADDRESS_ELROND]);
    const accountElrond = computed(() => store.getters[USER_GETTERS.ACCOUNT_ELROND]);
    const userAvatar = computed(() => store.getters[USER_GETTERS.AVATAR]);

    const displayName = computed(() => {
      if (!address.value || !accountElrond.value) {
        return '';
      }

      const username = store.getters[USER_GETTERS.USERNAME];
      if (username) return "@" + username;

      if (accountElrond.value.userName) {
        return "@" + accountElrond.value.userName.replace(".elrond", "");
      }

      return formatterHelper.formatAddress(address.value);
    });

    onMounted(() => {
      // Load user preferences
      // Check localStorage first for faster loading
      const localUsername = localStorage.getItem("username");
      const localAvatar = localStorage.getItem("avatar");
      const localBanner = localStorage.getItem("banner");

      if (localUsername) {
        store.commit(USER_MUTATIONS.USERNAME, localUsername);
      }

      if (localAvatar) {
        store.commit(USER_MUTATIONS.AVATAR, localAvatar);
      }

      if (localBanner) {
        store.commit(USER_MUTATIONS.BANNER, localBanner);
      }
    });

    return {
      route,
      ROUTES,
      address,
      accountElrond,
      userLogoutElrond: logout,
      formatAddress,
      formatTokenTransfer,
      goToAccountPage,
      logout,
      userAvatar,
      displayName,
    };
  },
});
